import { SidebarMenuItem } from "../../Types/Layout.type";

export const menuList: SidebarMenuItem[] = [
  {
    title: "",
    items: [
      {
        title: "Dashboard",
        id: 1,
        icon: "iconly-Home icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMDashboard`,
        active: false,
        roles: [1],
      },
      {
        title: "All Leads",
        id: 2,
        icon: "iconly-User2 icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/LeadsProperty`,
        active: false,
        roles: [1, 2, 3, 4, 5, 6],
      },
      // One task list. Task Property, Task Finance and Task RH were three copies of
      // the same 893 line page pointed at different filters; with Finance and Mortgage
      // Broking gone there is only one kind of follow up left, so there is one list.
      // Roles are the union of the three, so nobody loses the list they had.
      {
        title: "Tasks",
        id: 2,
        icon: "iconly-Star icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMTaskList`,
        active: false,
        roles: [1, 2, 6],
      },
      // {
      //   title: "Task - MMP",
      //   id: 22,
      //   icon: "iconly-Tick-Square icli",
      //   type: "main",
      //   path: `${process.env.PUBLIC_URL}/CRMTaskMMP`,
      //   active: false,
      //   roles: [1, 5],
      // },

      {
        title: "Prop Search",
        id: 4,
        icon: "iconly-Location icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMPropertySearch`,
        active: false,
        roles: [1, 2, 4],
      },
      {
        title: "Prop Builder",
        id: 5,
        icon: "iconly-Work icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMBuilders`,
        active: false,
        roles: [1],
      },
      {
        title: "Prop Suburb",
        id: 8,
        icon: "iconly-Map icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMSuburb`,
        active: false,
        roles: [1],
      },
      {
        title: "Fin Lenders",
        id: 9,
        icon: "iconly-Bank icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMLenders`,
        active: false,
        roles: [1],
      },
      {
        title: "Fin Product",
        id: 10,
        icon: "iconly-Wallet icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMLoanProducts`,
        active: false,
        roles: [1],
      },
      {
        title: "MMP Calculator",
        id: 3,
        icon: "iconly-Buy icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMHomeLoan`,
        active: false,
        roles: [1, 5, 6],
      },
      {
        title: "MMP Client",
        id: 2,
        icon: "iconly-Profile icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMClient`,
        active: false,
        roles: [1],
      },
      {
        title: "Lead Source",
        id: 6,
        icon: "iconly-Send icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMLeadSource`,
        active: false,
        roles: [1],
      },
      {
        title: "Stages",
        id: 7,
        icon: "iconly-Category icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMStages`,
        active: false,
        roles: [1],
      },
      {
        title: "Staff",
        id: 8,
        icon: "iconly-2-User icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMStaff`,
        active: false,
        roles: [1],
      },
      
      {
        title: "Company",
        id: 11,
        icon: "iconly-Profile icli",
        type: "main",
        path: `${process.env.PUBLIC_URL}/CRMOperatorMembers`,
        active: false,
        roles: [7],
      },
    ],
  },
];